import CompanyRoutes from '../../../apiRoutes/CompanyRoutes';
import { api } from '../../ConsumeApiController';


export async function searchPosProducts(merchantUuid, query = '', categoryId = null) {
    try {
        const url = CompanyRoutes.POS.PRODUCTS_SEARCH;
        const response = await api.post(url, { 
            merchant_uuid: merchantUuid,
            query: query,
            category_id: categoryId
        });

        // Retornamos el array de productos filtrados o vacío
        return response.success ? response.data : [];
    } catch (error) {
        console.error("Error filtering products:", error);
        return [];
    }
}

export async function initPos(merchantUuid) {
    try {
        const url = CompanyRoutes.POS.INIT;
        const response = await api.post(url, { merchant_uuid: merchantUuid });

        if (response.success) {
            const { categories, top_products, exchange_rate, country_id, payment_methods } = response.data;
            return { 
                categories, 
                top_products ,
                exchange_rate,
                country_id,
                payment_methods
            };
        }

        return { categories: [], top_products: [] };

    } catch (error) {
        console.error("Error al inicializar el catálogo POS:", error);
        return { categories: [], top_products: [] };
    }
}


export async function getPosProductDetails(merchantUuid,productId){
    try {
        const url = CompanyRoutes.POS.PRODUCT_DETAILS;
        const response = await api.post(url, { 
            merchant_uuid: merchantUuid,
            product_id: productId
        });

        // Retornamos el array de productos filtrados o vacío
        return response.success ? response.data : null;
    } catch (error) {
        console.error("Error fetching product details:", error);
        return null;
    }
}

export async function createPosOrder(merchantUuid, orderData) {
    try {
        // Asegúrate de definir esta constante en tu archivo CompanyRoutes
        const url = CompanyRoutes.POS.CREATE_ORDER; 
        
        const response = await api.post(url, { 
            merchant_uuid: merchantUuid,
            ...orderData // Esparcimos el resto de los datos (cliente, carrito, pagos)
        });

        // Retornamos la data (que probablemente incluya el ID de la factura generada)
        return response.success ? response.data : null;
    } catch (error) {
        console.error("Error creating POS order:", error);
        return null;
    }
}